import {layout} from '../../static/js/layout'
//解析layout-region
function analysisRgion(index) {
    let region = [];
    layout[index].forEach(layout=>{
        region.push(layout.region)
    });
    return region
};
export let roomJson = {
    "name":"test by client",
    "compere":"",
    "room":{
        "_id":"",
        "name":"enjoy tonight",
        "participantLimit": -1,
        "inputLimit": 1000,
        "roles":[
            {
                "role":"host",
                "passwd":"haha",
                "publish":{
                    "video":true,
                    "audio":true
                },
                "subscribe":{
                    "video":true,
                    "audio":true
                },
                "actions":[

                ]
            },
            {
                "role":"participant",
                "passwd":"xixi",
                "publish":{
                    "video":true,
                    "audio":true
                },
                "subscribe":{
                    "video":true,
                    "audio":true
                },
                "actions":[

                ]
            },
        ],
        "views":[
            {
                "label":"common",
                "audio":{
                    "format":{
                        "codec":"opus",
                        "sampleRate":48000,
                        "channelNum":2
                    },
                    "vad":true
                },
                "video":{
                    "format":{
                        "codec":"vp8",
                        "profile":""
                    },
                    "parameters":{
                        "resolution":{
                            "width":1920,
                            "height":1080
                        },
                        "framerate":30,
                        "bitrate":2048,
                        "keyFrameInterval":100
                    },
                    "maxInput":16,
                    "bgColor":{
                        "r":0,
                        "g":0,
                        "b":0
                    },
                    "motionFactor":0.8000,
                    "keepActiveInputPrimary":false,
                    "layout":{
                        "fitPolicy":"letterbox",
                        "templates":{
                            "base":"void",
                            "custom":[
                                {'region':analysisRgion(1)},
                                {'region':analysisRgion(2)},
                                {'region':analysisRgion(3)},
                                {'region':analysisRgion(4)},
                                {'region':analysisRgion(5)},
                                {'region':analysisRgion(6)},
                                {'region':analysisRgion(7)},
                                {'region':analysisRgion(8)},
                                {'region':analysisRgion(9)},
                                {'region':analysisRgion(10)},
                                {'region':analysisRgion(11)},
                                {'region':analysisRgion(12)},
                                {'region':analysisRgion(13)},
                                {'region':analysisRgion(14)},
                                {'region':analysisRgion(15)},
                                {'region':analysisRgion(16)},
                            ]
                        }
                    }
                }
            },
        ],
        "mediaIn":{
            "audio":[
                {
                    "codec":"opus",
                    "sampleRate":48000,
                    "channelNum":2
                },
                {
                    "codec":"isac",
                    "sampleRate":16000,
                    "channelNum":0
                },
                {
                    "codec":"isac",
                    "sampleRate":32000,
                    "channelNum":0
                },
                {
                    "codec":"g722",
                    "sampleRate":16000,
                    "channelNum":1
                },
                {
                    "codec":"pcma",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"pcmu",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"aac",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"ac3",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"nellymoser",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"ilbc",
                    "sampleRate":0,
                    "channelNum":0
                }
            ],
            "video":[
                {
                    "codec":"h264",
                    "profile":""
                },
                {
                    "codec":"vp8",
                    "profile":""
                },
                {
                    "codec":"vp9",
                    "profile":""
                }
            ]
        },
        "mediaOut":{
            "audio":[
                {
                    "codec":"opus",
                    "sampleRate":48000,
                    "channelNum":2
                },
                {
                    "codec":"isac",
                    "sampleRate":16000,
                    "channelNum":0
                },
                {
                    "codec":"isac",
                    "sampleRate":32000,
                    "channelNum":0
                },
                {
                    "codec":"g722",
                    "sampleRate":16000,
                    "channelNum":1
                },
                {
                    "codec":"pcma",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"pcmu",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"aac",
                    "sampleRate":48000,
                    "channelNum":2
                },
                {
                    "codec":"ac3",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"nellymoser",
                    "sampleRate":0,
                    "channelNum":0
                },
                {
                    "codec":"ilbc",
                    "sampleRate":0,
                    "channelNum":0
                }
            ],
            "video":{
                "format":[
                    {
                        "codec":"h264",
                        "profile":"CB"
                    },
                    {
                        "codec":"vp8",
                        "profile":""
                    },
                    {
                        "codec":"vp9",
                        "profile":""
                    }
                ],
                "parameters":{
                    "framerate":[
                        6,
                        12,
                        15,
                        24,
                        30,
                        48,
                        60
                    ],
                    "bitrate":[
                        "x0.8",
                        "x0.6",
                        "x0.4",
                        "x0.2"
                    ],
                    "keyFrameInterval":[
                        100,
                        30,
                        5,
                        2,
                        1
                    ],
                    "resolution":[
                        "x3/4",
                        "x2/3",
                        "x1/2",
                        "x1/3",
                        "x1/4",
                        "hd1080p",
                        "hd720p",
                        "svga",
                        "vga",
                        "cif"
                    ]
                }
            }
        },
        "transcoding":{
            "audio":true,
            "video":{
                "format":true,
                "framerate":true,
                "bitrate":true,
                "keyFrameInterval":true
            }
        },
        "notifying":{
            "participantActivities":true,
            "streamChange":true
        },
        "sip":{
            "sipServer":"",
            "username":"",
            "password":""
        }
    }
};
export let setmixInfo = function (curLayout,mixInterval,setteldStreams) {
    let mixInfo ={
        curLayout:curLayout,
        mixInterval:mixInterval,
        name:'mobile' ,
        setteldStreams:setteldStreams,
        hidenStreams:[]
    };
    return mixInfo
}
